import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './services/auth.service';
import { ClientPortalUsersService } from './services/client-portal-users.service';
import { UsersService } from './services/users.service';
import { concatMap, delay, firstValueFrom, map, Observable, of, switchMap, take, takeWhile, tap } from 'rxjs';
import { UserProfile } from './models/UserProfile';
import { ServerResponse } from './models/ServerResponse';
import { SnackBarService } from './services/snackbar.service';
import { SnackBarType } from './models/Snackbar';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
    constructor(
        private router: Router,
        private clientPortalUsersService: ClientPortalUsersService,
        private _userService: UsersService,
        private _authService: AuthService,
        private _snackbarService: SnackBarService
    ) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this._authService.tokenExpired) {
            return of(false);
        }

        if (await this._authService.isAuthenticated()) {
            // An OIDC session alone isn't enough: the client data must have been loaded at login
            if (!UsersService.getStoredClientData()) {
                localStorage.removeItem('ClientPortalUser');
                this.router.navigate(['/auth/login']);
                return false;
            }

            if (state.url == '/profile' && (!this._userService.userData?.entityExists || String.isNullOrUndefinedOrWhitespace(this._userService.userData?.tin)) ) {
                this.router.navigate(['/profile']).then( () => 
                    this._snackbarService.callSnackBar('FILL_ENTITY_DATA', SnackBarType.WARNING)
                )
            }
            return true;
        } else {
            this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }
    }

    // checkAuth(): boolean {
    //     // Your authentication logic here
    //     return !!localStorage.getItem('auth_token');
    // }
}